import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { Select, MenuItem, Box, TableCell } from "@mui/material";

import { RenderIf } from "..";
import { ReactComponent as MedicalCronologyIcon } from '../../assets/icons/MedicalCronologyIcon.svg'
import { ReactComponent as EditButtonIcon } from '../../assets/icons/EditButtonIcon.svg'
import { ReactComponent as DownloadButtonIcon } from '../../assets/icons/DownloadButtonIcon.svg'
import { ReactComponent as DeleteButtonIcon } from '../../assets/icons/DeleteButtonIcon.svg'
import { ReactComponent as InvoiceDownloadIcon } from '../../assets/icons/InvoiceDownloadIcon.svg';

import { CASE_TYPE, CASE_TYPE_DEMANDS, CASE_TYPE_MAP, DEMAND, DEMAND_TYPE } from "../../utils/enum";

const CaseActionControls = ({
    caseData,
    caseType,
    excludedDemands = [],
    editCaseButtonClickHandler,
    downloadDemandDraft,
    downloadCaseInvoice,
    openDeleteCaseModal,
    changeTypeOfDemandDraftHandler,
}) => {
    const [typeOfDemandDraft, setTypeOfDemandDraft] = useState("");
    const { _id, isCaseEdited, caseInfo, invoiceFilePath, isDraftCase } = caseData;
    const caseName = caseInfo?.caseName;

    const handleDemandChange = (value, setFieldValue) => {
        setFieldValue("typeOfDemand", value);
        setTypeOfDemandDraft(value);
        changeTypeOfDemandDraftHandler(value);
    };

    return (
        <>
            {/* Demand Dropdown + Conditional Buttons */}
            <TableCell sx={{ padding: "10px 5px" }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Formik initialValues={{ typeOfDemand: "" }} onSubmit={() => { }}>
                        {({ setFieldValue }) => (
                            <Form>
                                <Field
                                    as={Select}
                                    name="typeOfDemand"
                                    displayEmpty
                                    sx={{
                                        width: "12.5rem",
                                        height: "1.75rem",
                                        backgroundColor: "#F2F2F2",
                                        borderRadius: "4px 0px 0px 4px",
                                    }}
                                    disablescrolllock="true"
                                    onChange={(e) =>
                                        handleDemandChange(e.target.value, setFieldValue)
                                    }
                                >
                                    <MenuItem value="">Select Demand Type</MenuItem>
                                    {caseType &&
                                        CASE_TYPE_DEMANDS?.[caseType]
                                            ?.filter((v) => !excludedDemands.includes(v))
                                            ?.map((v, idx) => {
                                                const option = DEMAND_TYPE?.[v];
                                                return (
                                                    <MenuItem key={idx} value={option?.value}>
                                                        {option?.text}
                                                    </MenuItem>
                                                );
                                            })}
                                </Field>
                            </Form>
                        )}
                    </Formik>

                    {/* Delete / Download Buttons */}
                    <RenderIf shouldRender={isDraftCase === true}>
                        <button
                            className="btn btn-theme caseBtn"
                            style={{
                                padding: "5px 8px",
                                minWidth: "auto",
                                lineHeight: "0",
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                            }}
                            onClick={() => openDeleteCaseModal(_id)}
                        >
                            <DeleteButtonIcon />
                        </button>
                    </RenderIf>

                    <RenderIf shouldRender={!isDraftCase}>
                        <button
                            className="btn btn-theme caseBtn"
                            style={{
                                padding: "5px 8px",
                                minWidth: "auto",
                                lineHeight: "0",
                                borderTopLeftRadius: 0,
                                borderBottomLeftRadius: 0,
                            }}
                            onClick={() =>
                                downloadDemandDraft({
                                    caseId: _id,
                                    caseName,
                                    typeOfDemandDraft,
                                })
                            }
                        >
                            <DownloadButtonIcon />
                        </button>
                    </RenderIf>
                </Box>
            </TableCell>

            {/* Edit Button */}
            <TableCell sx={{ padding: "10px 5px" }}>
                <button
                    className="btn btn-theme caseBtn"
                    style={{
                        padding: "5px 8px",
                        minWidth: "auto",
                        lineHeight: "0",
                    }}
                    onClick={() => editCaseButtonClickHandler(_id)}
                >
                    <EditButtonIcon />
                </button>
            </TableCell>

            {/* Medical Chronology Button */}
            <TableCell sx={{ padding: "10px 5px" }}>
                <button
                    disabled={isDraftCase === true}
                    className="btn btn-theme caseBtn"
                    style={{
                        padding: "5px 8px",
                        minWidth: "auto",
                        lineHeight: "0",
                    }}
                    onClick={() =>
                        downloadDemandDraft({
                            caseId: _id,
                            caseName,
                            typeOfDemandDraft: DEMAND.Medical_Chronology,
                        })
                    }
                >
                    <MedicalCronologyIcon />
                </button>
            </TableCell>

            {/* Invoice Download Button */}
            <TableCell sx={{ padding: "10px 5px" }}>
                <button
                    disabled={!invoiceFilePath}
                    className="btn btn-theme caseBtn"
                    style={{
                        padding: "5px 8px",
                        minWidth: "auto",
                        lineHeight: "0",
                    }}
                    onClick={() =>
                        downloadCaseInvoice({
                            caseId: _id,
                            caseName,
                        })
                    }
                >
                    <InvoiceDownloadIcon />
                </button>
            </TableCell>
        </>
    );
};

export default CaseActionControls;